<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-04 20:05:45
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\InternalUse\components\toApply.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-24 13:18:17
-->
<template>
  <normalDialog
    :title="$t('label_essweb_myLeaveApplication_list_dialog_newLeaveTitle')"
    :dialog="show"
    width="800"
    @close="closeDialog"
  >
    <template v-slot:content>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showHeader="false"
        :needScrollX="false"
      >
        <template v-slot:item.type="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.leave_type_name) }}
          </div>
        </template>
        <template v-slot:item.unit="{ item }">
          <div class="text--primary table-title">
            {{
              item.unit == "D"
                ? $t("label_essweb_system_dayLabel")
                : item.unit == "H"
                ? $t("label_essweb_system_hourLabel")
                : $t("label_essweb_system_minutesLabel")
            }}
          </div>
        </template>
        <template v-slot:item.pending="{ item }">
          <div
            class="text--primary table-title"
            v-if="Number(item.is_show_pending)"
          >
            {{
              item.leave_pending | CalculationByDHFilter(item, CalculationByDH)
            }}
          </div>
        </template>
        <template v-slot:item.balance="{ item }">
          <div
            class="text--primary table-title"
            v-if="Number(item.is_show_balance)"
          >
            {{
              item.leave_balance | CalculationByDHFilter(item, CalculationByDH)
            }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            rounded
            v-if="Number(item.is_allow_apply)"
            color="primary"
            class="text-button"
            small
            @click="toApply(item.leave_type_uuid)"
          >
            {{
              $t("label_essweb_LeaveApplication_list_dialog_applyBtnLabel")
            }}</v-btn
          >
        </template>
      </Tabler>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    show: { default: false, type: Boolean },
    staff_uuid: { default: null, type: [Number, String] },
  },
  computed: {},
  watch: {
    staff_uuid(val) {
      if (val) this.getLeaveType(val);
    },
  },
  data() {
    return {
      standard_working_minutes: 1,
      headers: [
        {
          text: "label_essweb_leaveApplication_list_leaveType",
          value: "type",
          align: "start",
          sortable: false,
        },

        // {
        //   text: "label_essweb_myLeaveApplication_form_pendingLabel",
        //   value: "pending",
        //   align: "start",
        //   sortable: false,
        // },
        // {
        //   text: "label_essweb_leaveBalance_form_tab_BalanceLabel",
        //   value: "balance",
        //   align: "start",
        //   sortable: false,
        // },
        // {
        //   text: "label_essweb_leaveApplication_list_unitLabel",
        //   value: "unit",
        //   align: "start",
        //   sortable: false,
        // },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    if (this.staff_uuid) this.getLeaveType(this.staff_uuid);
  },
  filters: {
    CalculationByDHFilter: function (minutes, obj, callback) {
      return callback(minutes, obj["unit"]);
    },
  },
  methods: {
    CalculationByDH: function (minutes, unit) {
      let stand = this.standard_working_minutes;
      if (
        minutes === undefined ||
        minutes === null ||
        minutes === "" ||
        unit === null ||
        unit === ""
      ) {
        return minutes;
        // +  this.$t("label_essweb_system_minutesLabel");
      }
      if (unit === "D") {
        if (stand === "" || stand === null) {
          return minutes;
          // +  this.$t("label_essweb_system_minutesLabel");
        }
        return parseFloat((Number(minutes) / Number(stand)).toFixed(4));
        // +
        // this.$t("label_essweb_system_dayLabel")
      } else if (unit === "H") {
        return parseFloat((Number(minutes) / 60).toFixed(4));
        // +
        // this.$t("label_essweb_system_hourLabel")
      } else {
        return minutes;
        // +  this.$t("label_essweb_system_minutesLabel");
      }
    },
    getLeaveType: function (staff) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave/get-vacation-balance/",
        data: { staff_uuid: staff },
        global: false,
      }).then((res) => {
        that.standard_working_minutes = res.data["standard_working_minutes"];
        that.desserts = res.data["ess_lv_leave_balance"];
      });
    },
    toApply: function (id) {
      this.$emit("toApply", id);
    },
    closeDialog: function () {
      this.$emit("close");
    },
  },
};
</script>